/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  UpdateTenantDetailsByIDOptions,
  UpdateTenantDetailsByIDResponses,
} from '../types/UpdateTenantDetailsByID'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Update tenant details by ID
 * {@link /v1/tenants/:tenant_id}
 */
export function updateTenantDetailsByID<ThrowOnError extends boolean = true>(
  options: Options<UpdateTenantDetailsByIDOptions, ThrowOnError>,
): Unwrappable<RequestResult<UpdateTenantDetailsByIDResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'PUT',
      url: '/v1/tenants/{tenant_id}',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<UpdateTenantDetailsByIDResponses, ThrowOnError>>,
  )
}
